enum ToursTableAccessor {
  Date = 'date',
  Property = 'property',
  Status = 'status',
  Confirmed = 'isConfirmed',
  Actions = 'actions',
}

export { ToursTableAccessor };
